<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :loading="loading"
    :items="documents"
    :items-per-page="10"
    :disable-sort="$vuetify.breakpoint.smAndDown"
    :footer-props="{'items-per-page-text': 'Số Hồ Sơ một trang'}"
    v-bind="this.$attrs"
  >
    <template v-slot:[`footer.page-text`]="items">
      Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
    </template>
    <template v-slot:[`item.code`]="{item}">
      {{ item | getCode }}
    </template>
    <template v-slot:[`item.name`]="{item}">
      {{ item | getStudentName }}
    </template>
    <template v-slot:[`item.dob`]="{item}">
      {{ item | getStudentDob }}
    </template>
    <template v-slot:[`item.examMathMark`]="{item}">
      {{ item | getExamMathMark }}
    </template>
    <template v-slot:[`item.examLanguage`]="{item}">
      {{ item | getExamLanguage }}
    </template>
    <template v-slot:[`item.priorityMark`]="{item}">
      {{ item | getPriorityMark }}
    </template>
    <template v-slot:[`item.totalMark`]="{item}">
      {{ item | getTotalMark }}
    </template>
    <template v-slot:[`item.examPassText`]="{item}">
      <span :class="getColor(item)">{{ item | isPassExam }}</span>
    </template>
  </v-data-table>
</template>

<script>
const headers = [
  {text: 'Mã hồ sơ', value: 'code'},
  {text: 'Cơ sở', value: 'department'},
  {text: 'Họ và tên', value: 'name'},
  {text: 'Ngày sinh', value: 'dob'},
  {text: 'Điểm Kỹ năng Tư duy', value: 'examMathMark'},
  {text: 'Điểm Kỹ năng Ngôn ngữ', value: 'examLanguage'},
  {text: 'Điểm ưu tiên', value: 'priorityMark'},
  {text: 'Tổng điểm', value: 'examTotal'},
  {text: 'Kết quả trúng tuyển', value: 'examPassText'}
]
import {get} from 'lodash'
import moment from 'moment'
export default {
  props: {documents: Array},
  data: () => ({loading: false, headers}),
  methods: {
    getColor(item) {
      const passExamText = get(item, 'passExamText', '').toLowerCase()
      if (typeof passExamText === 'string' && passExamText.length) {
        if (passExamText.includes('đã trúng tuyển')) return 'success--text'
        if (passExamText.includes('không') || passExamText.includes('vi phạm') || passExamText.includes('chưa đạt đủ'))
          return 'error--text'
      }
      return ''
    }
  },
  filters: {
    getStudentName: item => get(item, 'name', '---'),
    getCode: item => get(item, 'code', '---'),
    getStudentDob: item => (item.dob ? moment(item.dob, 'DD/MM/YYYY').format('DD/MM/YYYY') : '---'),
    getExamMathMark: item => get(item, 'examMathMark', '---'),
    getPriorityMark: item => get(item, 'priorityMark', '---'),
    getExamLanguage: item => get(item, 'examLanguage', '---'),
    getTotalMark: item => get(item, 'examTotal', '---'),
    isPassExam: item => get(item, 'passExamText', '---')
  }
}
</script>
